/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import { positions, Provider as AlertProvider, transitions } from 'react-alert';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import {
  HashRouter, Route, Switch,
} from 'react-router-dom';
import { persistStore } from 'redux-persist';
import { PersistGate } from 'redux-persist/integration/react';
import store from './app/store';
import AppFooter from './components/AppFooter/AppFooter';
import Botao from './components/Botao/Botao';
import IniciarAcompanhamento from './screens/Acompanhamento/IniciarAcompanhamento';
import IniciarCartaServicos from './screens/CartaServicos/IniciarCartaServicos';
import SelecionarCartaServicos from './screens/CartaServicos/SelecionarCartaServicos';
import IniciarEnqueteConselho from './screens/EnquetesConselho/IniciarEnqueteConselho';
import IniciarEnquete from './screens/Enquetes/IniciarEnquete';
import IniciarGrafico from './screens/Grafico/IniciarGrafico';
import SelecionarCidade from './screens/Inicio/SelecionarCidade';
import SelecionarNoticias from './screens/Noticias/SelecionarNoticias';
import IniciarNoticia from './screens/Noticias/IniciarNoticia';
import IniciarEvento from './screens/Eventos/IniciarEvento';
import IniciarAgenda from './screens/Agenda/IniciarAgenda';
import SelecionarAgenda from './screens/Agenda/SelecionarAgenda';
import SelecionarEventos from './screens/Eventos/SelecionarEventos';
import SelecionarServico from './screens/Servicos/SelecionarServico';
import IniciarSic from './screens/Sic/IniciarSic';
import IniciarSicFrequentes from './screens/SicFrequentes/IniciarSicFrequentes';
import VisualizarUsuario from './screens/Usuario/VisualizarUsuario';
import {
  A11yButtonsContainer,
  A11yContainerControl,
  Linha, NotificacaoAviso, NotificacaoErro, NotificacaoSucesso,
} from './styles/base';
import SelecionarColetaDeLixo from './screens/ColetaDeLixo/SelecionarColetaDeLixo';
import IniciarColetaDeLixo from './screens/ColetaDeLixo/IniciarColetaDeLixo';
import SelecionarTransporteColetivo from './screens/TransporteColetivo/SelecionarTransporteColetivo';
import IniciarTransporteColetivo from './screens/TransporteColetivo/IniciarTransporteColetivo';
import SelecionarTelefonesUteis from './screens/TelefonesUteis/SelecionarTelefonesUteis';
import IniciarTelefonesUteis from './screens/TelefonesUteis/IniciarTelefonesUteis';
import SelecionarAplicacao from './screens/InicioTotem/SelecionarAplicacao';
import SelecionarOpcaoOuvidoria from './screens/InicioTotem/SelecionarOpcaoOuvidoria';
import EscolhaLogin from './screens/LoginTotem/EscolhaLogin';
import TotemLogin from './screens/LoginTotem/TotemLogin';
import VisualizarUsuarioTotem from './screens/UsuarioTotem/VisualizarUsuarioTotem';
import IniciarAcompanhamentoTotem from './screens/AcompanhamentoTotem/IniciarAcompanhamentoTotem';
import SelecionarSecretaria from './screens/InicioTotem/SelecionarSecretaria';
import SelecionarOpcaoSic from './screens/InicioTotem/SelecionarOpcaoSic';
import SelecionarOpcaoZeladoria from './screens/InicioTotem/SelecionarOpcaoZeladoria';
import SelecionarServicoTotem from './screens/ServicosTotem/SelecionarServicoTotem';
import IniciarTelefonesUteisTotem from './screens/TelefonesUteisTotem/IniciarTelefonesUteisTotem';
import SelecionarNoticiasTotem from './screens/NoticiasTotem/SelecionarNoticiasTotem';
import IniciarNoticiaTotem from './screens/NoticiasTotem/IniciarNoticiaTotem';
import SelecionarEventosTotem from './screens/EventosTotem/SelecionarEventosTotem';
import IniciarEventoTotem from './screens/EventosTotem/IniciarEventoTotem';
import SelecionarAgendaTotem from './screens/AgendaTotem/SelecionarAgendaTotem';
import IniciarAgendaTotem from './screens/AgendaTotem/IniciarAgendaTotem';
import SelecionarColetaDeLixoTotem from './screens/ColetaDeLixoTotem/SelecionarColetaDeLixoTotem';
import IniciarColetaDeLixoTotem from './screens/ColetaDeLixoTotem/IniciarColetaDeLixoTotem';
import SelecionarTransporteColetivoTotem from './screens/TransporteColetivoTotem/SelecionarTransporteColetivoTotem';
import IniciarTransporteColetivoTotem from './screens/TransporteColetivoTotem/IniciarTransporteColetivoTotem';
import SelecionarTelefonesUteisTotem from './screens/TelefonesUteisTotem/SelecionarTelefonesUteisTotem';
import { ReactComponent as AumentarFonteSvg } from './assets/icons/increase-font.svg';
import { ReactComponent as DiminuirFonteSvg } from './assets/icons/decrease-font.svg';
import { ReactComponent as ContrasteSvg } from './assets/icons/high-contrast.svg';
import { ReactComponent as AcessibilidadeSvg } from './assets/icons/a11y.svg';
import ModalAcessibilidade from './components/ModalAcessibilidade/ModalAcessibilidade';
import { getTotem } from './api/apiFactory';
import IniciarZeladoria from './screens/Zeladoria/IniciarZeladoria';
import IniciarOuvidoria from './screens/Ouvidoria/IniciarOuvidoria';

const App = () => {
  const persistor = persistStore(store);
  const alertOptions = {
    position: positions.BOTTOM_RIGHT,
    transition: transitions.FADE,
  };

  const AlertTemplate = ({
    style, message, close, options,
  }) => (
    <div style={style}>
      {options.type === 'info' && (
        <NotificacaoSucesso>
          <Linha style={{ justifyContent: 'flex-end' }}>
            <Botao fechar onClick={close} />
          </Linha>
          {options && options.title ? (
            <h4>{options.title}</h4>
          ) : (
            <h4>Sucesso</h4>
          )}
          <p>
            Dados gravados com sucesso.
            <br />
            {message}
          </p>
        </NotificacaoSucesso>
      )}
      {options.type === 'success' && (
        <NotificacaoSucesso>
          <Linha style={{ justifyContent: 'flex-end' }}>
            <Botao fechar onClick={close} />
          </Linha>
          {options && options.title ? (
            <h4>{options.title}</h4>
          ) : (
            <h4>Sucesso</h4>
          )}
          <p>{message}</p>
        </NotificacaoSucesso>
      )}
      {options.type === 'error' && (
        <NotificacaoErro>
          <Linha style={{ justifyContent: 'flex-end' }}>
            <Botao fechar onClick={close} />
          </Linha>
          {options && options.title ? (
            <h4>{options.title}</h4>
          ) : (
            <h4>Atenção</h4>
          )}
          <p>{message}</p>
        </NotificacaoErro>
      )}
      {options.type === 'warning' && (
        <NotificacaoAviso>
          <Linha style={{ justifyContent: 'flex-end' }}>
            <Botao fechar onClick={close} />
          </Linha>
          {options && options.title ? (
            <h4>{options.title}</h4>
          ) : (
            <h4>Aviso</h4>
          )}
          <p>{message}</p>
        </NotificacaoAviso>
      )}
    </div>
  );

  const [fontSize, setFontSize] = useState(1);

  const increaseFontSize = () => setFontSize((prevSize) => (prevSize === 1.2000000000000002 || prevSize === 1.2 ? 1.2000000000000002 : prevSize + 0.1));
  const decreaseFontSize = () => setFontSize((prevSize) => (prevSize === 0.8 ? 0.8 : prevSize - 0.1));

  const [contrast, setContrast] = useState(false);

  function controlarContraste() {
    if (!contrast) {
      document.body.style.filter = 'grayscale(1)';
    } else {
      document.body.style.filter = '';
    }

    setContrast(!contrast);
  }

  const [modalAcessibilidadeAberto, setModalAcessibilidadeAberto] = useState(false);

  const abrirModalAcessibilidade = () => {
    setModalAcessibilidadeAberto(true);
  };

  const fecharModalAcessibilidade = () => {
    setModalAcessibilidadeAberto(false);
  };

  // Evento que acontece com o click direito do mouse (Context Menu). Nesse caso eu desejo que o click com o direito NÃO funcione na versão totem.
  const handleContextMenu = (e) => {
    if (getTotem() === 'true') {
      e.preventDefault();
    }
  };

  return (
    <AlertProvider template={AlertTemplate} {...alertOptions}>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          {getTotem() !== 'true' && (
            <A11yButtonsContainer style={{ zoom: fontSize }}>
              <button title="Aumentar a fonte" aria-label="Aumentar a fonte" type="button" onClick={increaseFontSize}><AumentarFonteSvg /></button>
              <button title="Diminuir a fonte" aria-label="Diminuir a fonte" type="button" onClick={decreaseFontSize}><DiminuirFonteSvg /></button>
              <button title="Modo Contraste" aria-label="Ativar o Alto Contraste" type="button" onClick={controlarContraste}><ContrasteSvg /></button>
              <button title="Acessibilidade" aria-label="Acessibilidade" type="button" onClick={() => abrirModalAcessibilidade()}><AcessibilidadeSvg /></button>
            </A11yButtonsContainer>
          )}

          {(modalAcessibilidadeAberto && getTotem() !== 'true') && (
            <ModalAcessibilidade fecharModal={fecharModalAcessibilidade} contrast={contrast} />
          )}

          <A11yContainerControl style={{ zoom: fontSize }} contrast={contrast} onContextMenu={handleContextMenu}>
            <Switch>
              {/* Início eOuve Totem */}

              <Route exact path="/">
                <SelecionarCidade />
              </Route>
              <Route exact path="/totem">
                <SelecionarAplicacao />
              </Route>
              <Route exact path="/totem/ouvidoria">
                <SelecionarOpcaoOuvidoria />
              </Route>
              <Route exact path="/totem/sic">
                <SelecionarOpcaoSic />
              </Route>
              <Route exact path="/totem/zeladoria">
                <SelecionarOpcaoZeladoria />
              </Route>
              <Route exact path="/totem/ouvidoria/conta">
                <VisualizarUsuarioTotem ouvidoria />
              </Route>
              <Route exact path="/totem/sic/conta">
                <VisualizarUsuarioTotem sic />
              </Route>
              <Route exact path="/totem/zeladoria/conta">
                <VisualizarUsuarioTotem zeladoria />
              </Route>
              <Route exact path="/totem/ouvidoria/cadastrar">
                <SelecionarSecretaria ouvidoria />
              </Route>
              <Route exact path="/totem/sic/cadastrar">
                <SelecionarSecretaria sic />
              </Route>
              <Route exact path="/totem/zeladoria/cadastrar">
                <SelecionarSecretaria zeladoria />
              </Route>
              <Route exact path="/totem/ouvidoria/acompanhamento">
                <IniciarAcompanhamentoTotem ouvidoria />
              </Route>
              <Route exact path="/totem/sic/acompanhamento">
                <IniciarAcompanhamentoTotem sic />
              </Route>
              <Route exact path="/totem/zeladoria/acompanhamento">
                <IniciarAcompanhamentoTotem zeladoria />
              </Route>
              {/* sessão de login do totem */}
              <Route exact path="/totem/ouvidoria/acompanhamento/escolhalogin">
                <EscolhaLogin ouvidoria acompanhamento />
              </Route>
              <Route exact path="/totem/ouvidoria/cadastrar/escolhalogin">
                <EscolhaLogin ouvidoria cadastro />
              </Route>
              <Route exact path="/totem/sic/acompanhamento/escolhalogin">
                <EscolhaLogin sic acompanhamento />
              </Route>
              <Route exact path="/totem/sic/cadastrar/escolhalogin">
                <EscolhaLogin sic cadastro />
              </Route>
              <Route exact path="/totem/zeladoria/acompanhamento/escolhalogin">
                <EscolhaLogin zeladoria acompanhamento />
              </Route>
              <Route exact path="/totem/zeladoria/cadastrar/escolhalogin">
                <EscolhaLogin zeladoria cadastro />
              </Route>
              <Route exact path="/totem/ouvidoria/acompanhamento/login">
                <TotemLogin ouvidoria acompanhamento />
              </Route>
              <Route exact path="/totem/ouvidoria/cadastrar/login">
                <TotemLogin ouvidoria cadastro />
              </Route>
              <Route exact path="/totem/sic/acompanhamento/login">
                <TotemLogin sic acompanhamento />
              </Route>
              <Route exact path="/totem/sic/cadastrar/login">
                <TotemLogin sic cadastro />
              </Route>
              <Route exact path="/totem/zeladoria/acompanhamento/login">
                <TotemLogin zeladoria acompanhamento />
              </Route>
              <Route exact path="/totem/zeladoria/cadastrar/login">
                <TotemLogin zeladoria cadastro />
              </Route>
              {/* Sessao Servicos Totem */}
              <Route path="/totem/servicos">
                <SelecionarServicoTotem />
              </Route>
              <Route path="/totem/noticia/:id">
                <IniciarNoticiaTotem />
              </Route>
              <Route path="/totem/noticias">
                <SelecionarNoticiasTotem />
              </Route>
              <Route path="/totem/evento/:id">
                <IniciarEventoTotem />
              </Route>
              <Route path="/totem/eventos">
                <SelecionarEventosTotem />
              </Route>
              <Route path="/totem/agenda/:id">
                <IniciarAgendaTotem />
              </Route>
              <Route path="/totem/agendas">
                <SelecionarAgendaTotem />
              </Route>
              <Route path="/totem/coleta/:id">
                <IniciarColetaDeLixoTotem />
              </Route>
              <Route path="/totem/coletas">
                <SelecionarColetaDeLixoTotem />
              </Route>
              <Route path="/totem/transporte/:id">
                <IniciarTransporteColetivoTotem />
              </Route>
              <Route path="/totem/transportes">
                <SelecionarTransporteColetivoTotem />
              </Route>
              <Route path="/totem/telefone/:id">
                <IniciarTelefonesUteisTotem />
              </Route>
              <Route path="/totem/telefones">
                <SelecionarTelefonesUteisTotem />
              </Route>
              {/* Fim eOuve Totem */}

              {/* eOuve Padrão */}
              <Route path="/graficos">
                <IniciarGrafico />
              </Route>
              <Route path="/ouvidoria">
                <IniciarOuvidoria />
              </Route>
              <Route path="/sic">
                <IniciarSic />
              </Route>
              <Route path="/sic-frequentes">
                <IniciarSicFrequentes />
              </Route>
              <Route path="/conta">
                <VisualizarUsuario />
              </Route>
              <Route path="/acompanhamentos">
                <IniciarAcompanhamento />
              </Route>
              <Route path="/cartadeservicos/:id">
                <IniciarCartaServicos />
              </Route>
              <Route path="/cartadeservicos">
                <SelecionarCartaServicos />
              </Route>
              <Route path="/conselhomunicipal">
                <IniciarEnqueteConselho />
              </Route>
              <Route path="/servicos">
                <SelecionarServico />
              </Route>
              <Route path="/noticia/:id">
                <IniciarNoticia />
              </Route>
              <Route path="/noticias">
                <SelecionarNoticias />
              </Route>
              <Route path="/enquetes">
                <IniciarEnquete />
              </Route>
              <Route path="/evento/:id">
                <IniciarEvento />
              </Route>
              <Route path="/eventos">
                <SelecionarEventos />
              </Route>
              <Route path="/agenda/:id">
                <IniciarAgenda />
              </Route>
              <Route path="/agendas">
                <SelecionarAgenda />
              </Route>
              <Route path="/coleta/:id">
                <IniciarColetaDeLixo />
              </Route>
              <Route path="/coletas">
                <SelecionarColetaDeLixo />
              </Route>
              <Route path="/transporte/:id">
                <IniciarTransporteColetivo />
              </Route>
              <Route path="/transportes">
                <SelecionarTransporteColetivo />
              </Route>
              <Route path="/telefone/:id">
                <IniciarTelefonesUteis />
              </Route>
              <Route path="/telefones">
                <SelecionarTelefonesUteis />
              </Route>
              <Route path="/zeladoria">
                <IniciarZeladoria />
              </Route>
              <Route path="*">
                <SelecionarCidade />
              </Route>
              {/* Fim eOuve Padrão */}
            </Switch>
          </A11yContainerControl>
          <AppFooter />
        </PersistGate>
      </Provider>
    </AlertProvider>
  );
};

ReactDOM.render(
  <HashRouter>
    <App />
  </HashRouter>,
  document.getElementById('root'),
);
